import React, { useState } from "react";
import { Modal } from "react-bootstrap";

export function SessionModal(props) {

    return (
        <React.Fragment>
            <Modal
                show={props.show}
                onHide={props.onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <h4></h4> */}
                    <div>
                        Your session is about to expire soon. do you want to continue?
                    </div>
                  
                </Modal.Body>
                
                    <Modal.Footer>
                        <div>
                            <button className="btn common-button" onClick={props.onUpdateToParent}>{props.actionlabel}</button>
                            <button style={{ marginLeft: "5px" }} className="btn common-cancel-button" onClick={props.logOut}>No</button>
                        </div>
                    </Modal.Footer>)
                
               
            </Modal>



        </React.Fragment>
    )
}